'use es6';

import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import PropTypes from 'prop-types';
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import ObjectTypesType from 'customer-data-objects-ui-components/propTypes/ObjectTypesType';
import { jsx as _jsx } from "react/jsx-runtime";
const PreviewExpandableSection = styled(UIExpandableSection).withConfig({
  displayName: "UniversalSidebarCardDragPreview__PreviewExpandableSection",
  componentId: "sc-1bhc95r-0"
})(["background-color:", ";"], OLAF);
const UniversalSidebarCardDragPreview = ({
  item: {
    data: cardData
  },
  width
}) => {
  const {
    Title,
    Actions,
    objectId,
    objectType,
    data,
    cardProps
  } = cardData;
  return /*#__PURE__*/_jsx(PreviewExpandableSection, {
    open: false,
    titleText: /*#__PURE__*/_jsx(Title, Object.assign({
      data: data,
      objectId: objectId,
      objectType: objectType,
      subjectId: objectId /* todo subjectId -> objectId */
    }, cardProps)),
    actions: Actions && /*#__PURE__*/_jsx(Actions, {
      data: data,
      objectType: objectType,
      objectId: objectId
    }),
    style: {
      width
    }
  });
};
UniversalSidebarCardDragPreview.propTypes = {
  item: PropTypes.shape({
    data: PropTypes.shape({
      Title: PropTypes.elementType.isRequired,
      Actions: PropTypes.elementType,
      objectId: PropTypes.string.isRequired,
      objectType: PropTypes.oneOfType([ObjectTypesType, ObjectTypeIdType]).isRequired,
      data: PropTypes.object
    })
  }),
  width: PropTypes.number
};
export default UniversalSidebarCardDragPreview;